/* eslint-disable */

import { Injectable } from '@angular/core';
import { DebugLoggingCapsule } from '../use-case/feature-flags/capsule/debug-logging.capsule';
import { CONSTANTS } from './config.service';
import { DateTimeService } from './date-time/date-time.service';
import { GeowatcherService } from './geowatcher.service';
import { GisService } from './gis.service';
import { LoggerService } from './logger.service';
import { PersonsService } from './persons.service';
import { PosterService } from './poster.service';
import { PubSubService } from './pub-sub.service';
import { StorageService } from './storage.service';
import { StudyService } from './study.service';
import { TripSurveyService } from './trip-survey.service';
import { UtilsService } from './utils.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class TripSurveyInitializerService {
  isLongDistance: boolean;
  PICKUP_THRESHOLD_METERS = CONSTANTS.latePickup.MILES * this.gis.METERS_PER_MILE;
  busyLock = this.utils.createLock();

  constructor(
    private logger: LoggerService,
    private geowatcher: GeowatcherService,
    private gis: GisService,
    private pubSub: PubSubService,
    private utils: UtilsService,
    private persons: PersonsService,
    private poster: PosterService,
    private storage: StorageService,
    private study: StudyService,
    private tripSurvey: TripSurveyService,
    private dateTime: DateTimeService,
    private debugLoggingCapsule: DebugLoggingCapsule
  ) {
    this.logger.log('Trip survey initializer constructor', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
  }

  clearBusyLock() {
    this.utils.releaseLock(this.busyLock);
  }

  initSurveys() {
    const self = this;
    let created = false;
    let totalMeters = 0;
    let earlierStopTime;
    let earlierStopPoint;

    if (!CONSTANTS.IS_DEVICE) {
      return Promise.resolve(false);
    }

    if (this.isLongDistance) {
      this.logger.log('Initializing long trip surveys', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
      // TODO - removing busy locks for now
      return this.utils
        .waitForLock(this.busyLock)
        .then(() => this.storage.getUnsurveyedTrips())
        .then((trips: any[]) => {
          // trips in ASC id order
          let currTripSet = [];
          const promises = [];
          let i = 0;

          if (trips.length === 0) {
            return;
          }

          // into prev appDied/locationTimeout trips and non-appDied/locationTimeout terminator (appDied/locationTimeout trips at end: no survey for you)
          trips.forEach((trip) => {
            const clonedSet = currTripSet;
            trip.recordedStartTime = trip.startTime;
            currTripSet.push(trip);
            totalMeters += trip.furthestFromGeofenceMeters;
            i++;
            if (
              (trip.appDied === 0 && trip.locationTimeout === 0) ||
              // don't wait for interrupted trips to close if they push us over the LD line
              (this.study.isFinished() && i === trips.length && totalMeters > CONSTANTS.tripRecording.TRIP_METERS)
            ) {
              promises.push(
                this.tripSurvey
                  .autoCreateSurveys(clonedSet)
                  .then(() => {
                    this.logger.log('initSurveys updating has survey ' + clonedSet.length + 'x', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
                    created = true;
                    return this.storage.updateHasSurvey(clonedSet);
                  })
                  .catch((reason) => {
                    if (reason == 'Negative trip duration') {
                      this.logger.error(`LD survey(s) skipped ${reason}, segment id(s) ${clonedSet.map((s) => s.id)}`, MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
                      return Promise.resolve();
                    } else {
                      return Promise.reject(reason);
                    }
                  })
              );
              currTripSet = [];
            }
          });
          return Promise.all(promises);
        })
        .catch((reason) => {
          this.logger.error('Init LD surveys failed', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE, reason);
          // JS - removing this throw. we now reject any calls to initSurveys that occur while initSurveys is already running.
          // the catch handles these, so we don't want to 'throw'
          // throw 'Init LD surveys failed: ' + reason;
        })
        .then(() => {
          this.clearBusyLock();
          if (created) {
            this.logger.log('Publishing surveysCreated event from trip-survey-initr', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
            this.pubSub.publish(CONSTANTS.EVENTS.surveysCreated);
          }
        });
    } else {
      this.logger.log('TSI short surveys', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
      // return Promise.resolve();
      // TODO - busylock?
      //            return js.waitForLock(busyLock)
      //                 .then(function() {
      //                     return $q.all([storage.getUnsurveyedTrips(), tripSurvey.getLatestSurveyByPersonId($rootScope.memberId)]);
      //                 })

      // DEV commented lines for retrying survey creation
      //return Promise.all([this.geowatcher.clearHasSurvey([2]), this.tripSurvey.deleteSurvey(50)]) // TODO UNDO DEV ONLY
      //    .then(res => {
      //        this.logger.log('TSI clearHasSurvey, deleteSurvey', res);
      return (
        this.persons
          .getDeviceOwner()
          //    })
          .then((res) => {
            this.logger.log('TSI getDeviceOwner', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE, res);
            return Promise.all([this.storage.getUnsurveyedTrips(), this.tripSurvey.getLatestSurveyByPersonId(res.idx)]);
          })
          .then((results) => {
            const pointsPromises = [];
            let unsurveyedTrips;
            let previousSurvey;

            unsurveyedTrips = results[0];
            previousSurvey = results[1];

            this.logger.log('TSI unsurveyedTrips, previousSurvey', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE, unsurveyedTrips, previousSurvey);

            //if no previous survey, set stop to 0
            earlierStopTime = previousSurvey ? previousSurvey.stopTime : 0;
            earlierStopPoint = previousSurvey ? { lat: previousSurvey.stopLat, lon: previousSurvey.stopLon } : null;

            //get points for each trip
            // TODO points are only for distance - the distance could be collected as part of trip collection
            //      so less work needs to be done in the UI
            //      also using the 1st points time on the first trip,
            unsurveyedTrips.forEach((trip) => {
              // start time here is only to include 1st point after last stop
              const tripStartTime = Math.max(earlierStopTime + 1, trip.startTime);
              // point start time is for new trip start time, if needed
              const fetchPointTimes = true; // true b/c needed for splits
              // fetchPointTimes = trip.startTime < earlierStopTime,
              const fetchSplits = true;
              const fetchReverses = true;

              // TODO rename or split this out b/c we're also now fetching splits? (experimental)
              pointsPromises.push(
                self.storage
                  .getPointsForTimes(tripStartTime, trip.stopTime, fetchPointTimes, fetchSplits, fetchReverses)
                  .then((pointsData) => {
                    // used by server - don't modify
                    this.logger.log(
                      'trip', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE,
                      trip.id,
                      'splits',
                      this.utils.toJson(pointsData.splits.map((split) => [split[0], this.dateTime.getTimeFromTimestamp(split[1])])),
                      'reverses',
                      this.utils.toJson(
                        pointsData.reverses.map((reverse) => [reverse[0], reverse[1], this.dateTime.getTimeFromTimestamp(reverse[2])])
                      )
                    );
                    this.logger.info(
                      'getPointsForTimes splits, reverses', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE,
                      this.utils.toJson(pointsData.splits) + '|' + this.utils.toJson(pointsData.reverses)
                    );

                    trip.points = pointsData.locations;
                    trip.splits = pointsData.splits;
                    return trip;
                  })
              );
            });

            return Promise.all(pointsPromises);
          })
          .then((trips) => {
            const promises = [];

            if (!trips || trips.length === 0) {
              this.debugLoggingCapsule.logIfAble('No trips to create surveys for');
              return;
            }

            trips.forEach((trip, tripIdx) => {
              const tripDuration = trip.stopTime - trip.startTime;
              let secsSincePreviousTrip;
              let afterPickupMeters = 0;
              let uncappedThreshold;
              let cappedThreshold;

              // forEach continue; skip this trip b/c it will error out and block other surveys from being created
              if (tripDuration < 0) {
                this.logger.error(`Negative duration for segment id ${trip.id}`, MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
                promises.push(this.geowatcher.hideFromUi([trip]));
                return;
              }

              // forEach continue; skip this trip b/c no points will cause downstream issues
              if (!trip.points || trip.points.length == 0) {
                this.logger.error(
                  `No points to create trip survey for segment id ${trip.id}. trip.startTime: ${trip.startTime}, trip.stopTime: ${trip.stopTime}, earlierStopTime: ${earlierStopTime}`
                , MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);

                promises.push(this.geowatcher.hideFromUi([trip]));
                return;
              }

              // @Jevan - the trips have pickupMeters - is that no good?
              // points used for split trip off of trip.splits (from modes, experimental)
              for (let i = 1; i < trip.points.length - 1; i++) {
                const o = trip.points[i];
                const d = trip.points[i + 1];
                afterPickupMeters += this.gis.getDistance(o.lat, o.lon, d.lat, d.lon);
              }

              // TODO match with activity transitions to see when they started moving?
              trip.recordedStartTime = trip.startTime;
              if (trip.roughSpeedAfterPickup > -1) {
                const adjustedStartTime = trip.startTime - Math.round(trip.pickupMeters / trip.roughSpeedAfterPickup);
                if (earlierStopTime < adjustedStartTime) {
                  trip.startTime = adjustedStartTime;
                  trip.adjustedStartTime = adjustedStartTime;
                }
              }
              secsSincePreviousTrip = trip.startTime - earlierStopTime;

              // pickup at dwell? (i.e. 'teleport')
              if (
                CONSTANTS.latePickup.MIN_METERS < trip.pickupMeters &&
                trip.furthestAfterPickupMeters > -1 &&
                trip.furthestAfterPickupMeters <= CONSTANTS.tripRecording.NEAR_METERS
              ) {
                this.debugLoggingCapsule.logIfAble('Teleport detected for segment id ' + trip.id)

                trip.unknownStartTime = 1;
                trip.unknownStopTime = 1;

                // teleport and stop near previous stop? user might have already added a survey for this trip - prevent dupes
                if (earlierStopPoint) {
                  const stopDeltaMeters = this.gis.getDistanceFromInternalLatLons(
                    trip.stopLat,
                    trip.stopLon,
                    earlierStopPoint.lat,
                    earlierStopPoint.lon
                  );
                  if (stopDeltaMeters < CONSTANTS.tripRecording.GEOFENCE_RADIUS) {
                    promises.push(this.geowatcher.hideFromUi([trip]));
                    return;
                  }
                }
              } else {
                /*
                                    we want to see if the trip's pickup meters is beyond some threshold. if so, we flag and have the user confirm the start time
                                    we set the threshold based on the speed of the trip. if you're moving faster, we allow a higher threshold. if moving slower, it's a lower threshold.
                                    we arbitrarily cap the threshold between 1 mile and 5 miles.
                                    the threshold is calculated by how far you can travel in 6 minutes (arbitrary) at the calculated speed.
                                    at   1 mph, you can go .1 miles in 6 mins
                                    at  10 mph, you can go  1 mile  in 6 mins
                                    at  60 mph, you can go  6 miles in 6 mins
                                    at 100 mph, you can go 10 miles in 6 mins

                                    if the pickup meters is < 1 mile, never flag
                                    if the pickup meters is > 5 miles, always flag
                                    if its b/w 1 and 5 miles, compare to the calculated threshold
                                */

                // take the after pickup distnce and divide by trip duration for avg speed. multiply avg speed by 6 minutes to get the distance threshold.
                uncappedThreshold = (afterPickupMeters / tripDuration) * CONSTANTS.latePickup.FACTOR;
                // force the threshold to be between 1 and 5 miles
                cappedThreshold = Math.max(Math.min(CONSTANTS.latePickup.MAX_METERS, uncappedThreshold), CONSTANTS.latePickup.MIN_METERS);

                const message = `tripDuration: ${tripDuration}, afterPickupMeters: ${afterPickupMeters}, uncappedThreshold: ${uncappedThreshold}, cappedThreshold: ${cappedThreshold}`;
                this.debugLoggingCapsule.logIfAble(message);

                // if the user's pickup meters is greater than the calculated threshold, then flag it
                trip.unknownStartTime =
                  trip.pickupMeters > cappedThreshold && secsSincePreviousTrip > CONSTANTS.latePickup.SECONDS ? 1 : null;
                trip.unknownStopTime = null; //not doing this anymore
              }

              // handle prompting to split
              // if easier, pass these fields forward from the backend rather than re-calculating
              trip.duration = tripDuration;
              trip.afterPickupMeters = afterPickupMeters;

              promises.push(
                //this.tripSurvey.createTripSurvey(trip)
                //    .then(insertId => {
                // insertId might not be available if the row already existed (createForTripId has ON CONFLICT IGNORE)
                this.tripSurvey.createTripSurvey(trip).then((resolved) => {
                  created = true;
                  return self.storage.updateHasSurvey([trip]);
                })
                // .then((insertId: number) => {
                //     if (insertId && Number.isInteger(insertId)) {
                //         created = true;
                //         return this.storage.updateHasSurvey([trip]);
                //     } else {
                //         // TODO - fix this logger.
                //         //return this.logger.getErrorReporter('Id unexpected from insert trip survey')(arguments);
                //     }
                // },
                // function () {
                //     let beforeRetryArgs = arguments;
                //     // rare, but happened - created survey but trip wasn't updated; patch
                //     return this.tripSurvey.wasCreatedFor(trip.id)
                //         .then(function (surveyExists) {
                //             if (surveyExists) {
                //                 return this.storage.updateHasSurvey([trip]);
                //             } else {
                //                 return Promise.reject(null);
                //             }
                //         })
                //         .catch(function(reason) {
                //             return this.logger.getErrorReporter('Could not create trip survey')(beforeRetryArgs, arguments, reason);
                //            });
                // })
              );

              earlierStopTime = trip.stopTime;
              earlierStopPoint = { lat: trip.stopLat, lon: trip.stopLon };
            });
            return Promise.all(promises);
          })
          .catch((reason) => {
            // TODO logger errors
            const prunedReason = self.utils.toPrunedJson(reason);
            const message = `Init SD surveys failed: ${prunedReason}`;
            this.debugLoggingCapsule.logIfAble(message);
          })
          .then(() => {
            this.debugLoggingCapsule.logIfAble('Finished trip-survey-init');

            // TODO - busy lock?
            // clearBusyLock();
            if (created) {
              this.logger.log('Publishing surveysCreated event from trip-survey-init', MSRemoteLoggerCategory.TRIP_SURVEY_INITIALIZER_SERVICE);
              this.pubSub.publish(CONSTANTS.EVENTS.surveysCreated);
            }
            return Promise.resolve(null);
          })
      );
    }
  }

  initialize(longDistance) {
    this.isLongDistance = longDistance;
    // this.pubSub.subscribe(CONSTANTS.EVENTS.tripEnded, (...args) => {
    //     this.logger.log('Trip ended event triggering init surveys in trip survey initr')
    //     this.initSurveys();
    // });
    return Promise.resolve();
  }
}
